// @flow

// NOTE: This Flow module has a corresponding ambient TypeScript declaration in app/types/flow-modules.d.ts. Keep them in sync until this file is migrated to TypeScript.

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import GUATEMALA from '@tectonics/commons/country/countries/guatemala';

export function guatemalanOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  if (!GUATEMALA.customerForm) {
    throw new Error('Guatemala country object does not have an implemented customerForm');
  }

  const document = GUATEMALA.customerForm.document;
  if (!document) {
    throw new Error('Guatemala country object does not have an implemented document in customerForm');
  }

  return {
    country: 'gt',
    document: userInputValues[document.inputFieldName],
    zipcode: userInputValues['guatemalanZipcode'],
    state: userInputValues['guatemalanState'],
    city: userInputValues['guatemalanCity'],
    address: userInputValues['guatemalanAddress'],
    street_number: userInputValues['guatemalanStreetNumber'],
    street_complement: userInputValues['guatemalanStreetComplement'],
    phone_number: userInputValues['guatemalanPhoneNumber'],
  };
}
